import { css } from 'linaria';
export const typeAheadWrapper = "t1bajq8v";
export const TypeAheadMenu = ({
  children
}) => <div className={typeAheadWrapper}>{children}</div>;

require("./type-ahead.menu.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./type-ahead.menu.js");